import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blogFilter'
})
export class BlogFilterPipe implements PipeTransform {

  transform(blogs: any[], filter: Object): any {
    let key = Object.keys(filter)[0]
    if (!blogs || !key || !filter[key]) {
      return blogs
    }
    return blogs.filter(blog => blog[key] == filter[key])
  }

}
